import { graphql } from 'gql'

export const UPDATE_DOMAIN_INTERSTITIAL = graphql(`
  mutation updateDomainInterstitial(
    $input: UpdateDomainRichPlacementInterstitialConfigurationInput!
  ) {
    updateDomainRichPlacementInterstitialConfiguration(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`)
